<div class="surface-card shadow-2 border-round p-4">
  <div class="flex justify-content-between align-items-center mb-3 pb-3 border-bottom-1 border-200">
    <div class="flex align-items-center gap-2">
      <i class="pi pi-folder-open text-primary text-xl"></i>
      <span class="text-900 font-semibold text-xl">Customer Files</span>
      <p-badge
        *ngIf="files && files.length > 0"
        [value]="files.length.toString()"
        severity="info"
        styleClass="ml-1"
      ></p-badge>
    </div>
    <button
      *ngIf="showUploadButton"
      pButton
      pRipple
      icon="pi pi-upload"
      label="Upload File"
      class="p-button-sm p-button-primary"
      (click)="onUploadClick()"
    ></button>
  </div>

  <ng-container *ngIf="files?.length === 0; else showFiles">
    <div
      class="flex flex-column align-items-center justify-content-center py-6 border-2 border-dashed border-200 border-round-lg"
    >
      <div
        class="flex align-items-center justify-content-center w-4rem h-4rem border-circle bg-primary-50 mb-3"
      >
        <i class="pi pi-file text-primary text-2xl"></i>
      </div>
      <span class="text-900 font-semibold text-lg mb-1">No Files Available</span>
      <span class="text-500 text-sm text-center"
        >No files have been uploaded for this customer yet.</span
      >
    </div>
  </ng-container>

  <ng-template #showFiles>
    <div class="flex flex-column gap-2">
      <div
        *ngFor="let file of files"
        class="flex align-items-center justify-content-between gap-3 p-3 border-1 border-200 border-round-lg surface-50 hover:surface-100 transition-colors transition-duration-150"
      >
        <div class="flex align-items-center gap-3 min-w-0 flex-1">
          <div
            class="flex align-items-center justify-content-center w-2rem h-2rem border-circle bg-primary-50 flex-shrink-0"
          >
            <i class="pi pi-file text-primary text-sm"></i>
          </div>
          <div class="min-w-0 flex-1">
            <div
              class="text-900 font-medium text-sm white-space-nowrap overflow-hidden text-overflow-ellipsis"
            >
              {{ file.original_filename || 'Unnamed file' }}
            </div>
            <div class="flex align-items-center gap-2 mt-1">
              <span class="text-400 text-xs font-mono">{{ file.unique_file_reference }}</span>
              <span *ngIf="file.date_uploaded" class="text-400 text-xs">·</span>
              <span *ngIf="file.date_uploaded" class="text-400 text-xs">{{
                file.date_uploaded | date: 'd MMM y'
              }}</span>
              <span *ngIf="file.document_type" class="text-400 text-xs">·</span>
              <span *ngIf="file.document_type" class="text-400 text-xs uppercase">{{
                file.document_type
              }}</span>
            </div>
          </div>
        </div>
        <button
          (click)="downloadFile(file.unique_file_reference || '', file.original_filename || '')"
          pButton
          pRipple
          icon="pi pi-download"
          class="p-button-rounded p-button-text p-button-sm flex-shrink-0"
          [attr.aria-label]="'Download file: ' + (file.original_filename || '')"
        ></button>
      </div>
    </div>
  </ng-template>
</div>
